import React, { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import { setToastMessage, selectToastMessage } from "../../../main/slices/utilSlice";
import './ToastMessage.scss';
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { useAppDispatch, useAppSelector } from "../../../main/hooks/hooks";

const ToastMessage = () => {
    const dispatch = useAppDispatch();
    const [open, setOpen] = useState(false);
    const {
        toastMessage
    } = useAppSelector((state) => ({
        toastMessage: selectToastMessage(state)
    }));

    useEffect(() => {
        if (Object.keys(toastMessage)?.length) {
            setOpen(true);
        }
    }, [toastMessage]);

    const handleClose = (e: any, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        dispatch(setToastMessage({}));
    }

    const getDisplayMessage = () => {
        const message = toastMessage?.message;
        const reports = window.location.pathname.includes('reports');
        const graph = window.location.pathname.includes('graph');
        let friendlyMessage = message;
        
        // Switch for friendly messages for known error codes (Can add more as needed)
        switch (true) {
            case message?.includes('409') && (reports || graph):
                friendlyMessage = "An entity with this name already exists. Please choose a different name.";
                break;
            case (message?.includes('413') || message?.includes('400')) && (reports || graph):
                friendlyMessage = "The search selected is too large. Please redefine your target.";
                break;
            case message?.includes('400'):
                friendlyMessage = "The request was invalid. Please check your input and try again.";
                break;
            case message?.includes('401'):
                friendlyMessage = "You need to log in again to continue.";
                break;
            case message?.includes('403'):
                friendlyMessage = "You don't have permission to access this resource.";
                break;
            case message?.includes('404'):
                friendlyMessage = "The requested resource could not be found.";
                break;
            case message?.includes('413'):
                friendlyMessage = "The request entity is too large.";
                break;
            case message?.includes('429'):
                friendlyMessage = "Too many requests. Please wait a moment and try again.";
                break;
            case message?.includes('500'):
                friendlyMessage = "An unexpected error occurred. Please try again later.";
                break;
            case message?.includes('502'):
                friendlyMessage = "The server is temporarily unavailable. Please try again in a few minutes.";
                break;
            case message?.includes('503'):
                friendlyMessage = "The service is temporarily unavailable. Please try again later.";
                break;
            case message?.includes('504'):
                friendlyMessage = "The server took too long to respond. Please try again.";
                break;
        }
                
        return friendlyMessage?.split('\n').map((line, i) => (
            <React.Fragment key={i}>
                {line}
                {i < friendlyMessage.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    if (Object.keys(toastMessage)?.length > 0) {
        return (
            <Snackbar
                open={open}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                autoHideDuration={toastMessage.type === 'error' ? null : 7000}
                onClose={handleClose}
            >
                <Alert
                    onClick={handleClose}
                    variant="filled"
                    severity={toastMessage.type}
                    color={toastMessage.type}
                    style={{ whiteSpace: 'pre-line' }}
                >
                    {getDisplayMessage()}
                    <span className="close-icon">
                        <CloseOutlined onClick={handleClose} />
                    </span>
                </Alert>
            </Snackbar>
        );
    } else {
        return null;
    }
};

export default ToastMessage;